/* eslint-disable import/no-anonymous-default-export */
export default {
    temperature: '溫度',
    humidity: '濕度',
    air_pressure: '氣壓',
    co2: '二氧化碳',
    humiture: '溫度、濕度',
    pm2510: 'PM2.5、PM10',
    etvoc: 'eTVOC',
    noise: '噪聲',
    light: '光線',
}